import {Button, ButtonProps} from '@sail/ui';

interface SubmitButtonProps
  extends Omit<ButtonProps, 'dangerouslySetInnerHTML' | 'contentEditable'> {
  disabled: boolean;
  pending: boolean;
  children: React.ReactNode;
}

export const SubmitButton = ({
  disabled,
  pending,
  children,
  ...props
}: SubmitButtonProps) => {
  return (
    <Button
      {...props}
      css={{
        width: '100%',
      }}
      disabled={disabled}
      pending={pending}
    >
      {children}
    </Button>
  );
};
